const productType_Types = {
    CREATE_PRODUCT_TYPE_ACTION: "CREATE_PRODUCT_TYPE_ACTION",
    GET_PRODUCT_TYPE_COUNT_ACTION: "GET_PRODUCT_TYPE_COUNT_ACTION",
    GET_LIST_PRODUCT_TYPE_ACTION: "GET_LIST_PRODUCT_TYPE_ACTION",
    GET_LIST_ALL_PRODUCT_TYPE_ACTION: "GET_LIST_ALL_PRODUCT_TYPE_ACTION",
    GET_DETAIL_PRODUCT_TYPE_ACTION: "GET_DETAIL_PRODUCT_TYPE_ACTION",
    CLEAR_PRODUCT_TYPE_ACTION: "CLEAR_PRODUCT_TYPE_ACTION",
    UPDATE_PRODUCT_TYPE_ACTION: "UPDATE_PRODUCT_TYPE_ACTION",
    CREATE_PRODUCT_TYPE_SUCCESS: "CREATE_PRODUCT_TYPE_SUCCESS",
    GET_PRODUCT_TYPE_COUNT_SUCCESS: "GET_PRODUCT_TYPE_COUNT_SUCCESS",
    GET_LIST_PRODUCT_TYPE_SUCCESS: "GET_LIST_PRODUCT_TYPE_SUCCESS",
    GET_LIST_ALL_PRODUCT_TYPE_SUCCESS: "GET_LIST_ALL_PRODUCT_TYPE_SUCCESS",
    GET_DETAIL_PRODUCT_TYPE_SUCCESS: "GET_DETAIL_PRODUCT_TYPE_SUCCESS",
    UPDATE_PRODUCT_TYPE_SUCCESS: "UPDATE_PRODUCT_TYPE_SUCCESS",
    CREATE_PRODUCT_TYPE_FAILED: "CREATE_PRODUCT_TYPE_FAILED",
    GET_PRODUCT_TYPE_COUNT_FAILED: "GET_PRODUCT_TYPE_COUNT_FAILED",
    GET_LIST_PRODUCT_TYPE_FAILED: "GET_LIST_PRODUCT_TYPE_FAILED",
    GET_LIST_PRODUCT_TYPE_ALL_FAILED: "GET_LIST_ALL_PRODUCT_TYPE_FAILED",
    GET_DETAIL_PRODUCT_TYPE_FAILED: "GET_DETAIL_PRODUCT_TYPE_FAILED",
    UPDATE_PRODUCT_TYPE_FAILED: "UPDATE_PRODUCT_TYPE_FAILED",
    CLEAR_PRODUCT_TYPE_ACTION: "CLEAR_PRODUCT_TYPE_ACTION",
}

export default productType_Types;